export default "__VITE_ASSET__CUqoVznT__"